import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ExtractPlanReviewRequirementsMutationVariables = Types.Exact<{
  input: Types.ExtractPlanReviewRequirementsInput;
}>;


export type ExtractPlanReviewRequirementsMutation = { __typename?: 'mutation_root', extract_plan_review_requirements?: { __typename?: 'ExtractPlanReviewRequirementsOutput', success: boolean, extraction_id?: any | null, error?: string | null } | null };


export const ExtractPlanReviewRequirementsDocument = gql`
    mutation extractPlanReviewRequirements($input: ExtractPlanReviewRequirementsInput!) {
  extract_plan_review_requirements(input: $input) {
    success
    extraction_id
    error
  }
}
    `;
export type ExtractPlanReviewRequirementsMutationFn = Apollo.MutationFunction<ExtractPlanReviewRequirementsMutation, ExtractPlanReviewRequirementsMutationVariables>;

/**
 * __useExtractPlanReviewRequirementsMutation__
 *
 * To run a mutation, you first call `useExtractPlanReviewRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtractPlanReviewRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extractPlanReviewRequirementsMutation, { data, loading, error }] = useExtractPlanReviewRequirementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExtractPlanReviewRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<ExtractPlanReviewRequirementsMutation, ExtractPlanReviewRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExtractPlanReviewRequirementsMutation, ExtractPlanReviewRequirementsMutationVariables>(ExtractPlanReviewRequirementsDocument, options);
      }
export type ExtractPlanReviewRequirementsMutationHookResult = ReturnType<typeof useExtractPlanReviewRequirementsMutation>;
export type ExtractPlanReviewRequirementsMutationResult = Apollo.MutationResult<ExtractPlanReviewRequirementsMutation>;
export type ExtractPlanReviewRequirementsMutationOptions = Apollo.BaseMutationOptions<ExtractPlanReviewRequirementsMutation, ExtractPlanReviewRequirementsMutationVariables>;